// extracted by mini-css-extract-plugin
export default {"avatarRoot":"Avatar_avatarRoot__c7ShM","sizeMedium":"Avatar_sizeMedium__ftcbi"};